import React, { useEffect, useMemo } from 'react'
import PageTitleCard from '../cards/PageTitleCard'
import PageContainer from '../containers/PageContainer'
import PageTitleText from '../texts/PageTitleText'
import { useTranslation } from 'react-i18next'
import PrivacyPolicyText from '../common/PrivacyPolicyText'

type Props = {}

const PrivacyPolicyPage = (props: Props) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `QuickPick - ${t("navigation.privacy_policy")}`;
    }, [t("navigation.privacy_policy")]);

    return (
        <div>
            <PageContainer>
                <PageTitleCard>
                    <PageTitleText>
                        {t("navigation.privacy_policy")}
                    </PageTitleText>
                </PageTitleCard>
                <PrivacyPolicyText />
            </PageContainer>
        </div>
    )
}

export default PrivacyPolicyPage